export default {"src":"/_next/static/media/products-courses.eca81d80.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};